import { SelectFormsy, TextFieldFormsy } from '@fuse';
import axios from 'axios';
import classNames from 'classnames';
import Formsy from 'formsy-react';
import { Button, Icon, MenuItem, TextField, Toolbar, Tooltip } from 'material-ui';
import { withStyles } from 'material-ui/styles';
import Loader from "other-components/loader/loader";
import React, { Component } from 'react';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import ReactTable from "react-table";

import 'react-select/dist/react-select.css';

class jobNew extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            selectedJobs: "",
            activeJobs: [],
            pendingTasks: ' ',
            remainingDays: ' ',
            deadLine: ' ',
            subTasks: [],
            employees: [],
            assignDate: new Date().getFullYear() + "-" + ("0" + ((new Date().getMonth() + 1).toString())).substr(-2) + "-" + ("0" + (new Date().getDate().toString())).substr(-2),
        };

        this.setSelectedJobs = this.setSelectedJobs.bind(this);

    }


    setSelectedJobs = selectedOption => {
        // if (selectedOptions) {
        //     this.setState({ selectedJobs: selectedOptions.value });
        //     this.getTasks(selectedOptions.value);
        // }
        // else {

        //     this.setState({ pendingTasks: " " });
        //     this.setState({ remainingDays: " " });
        //     this.setState({ deadLine: " " });
        // }

        this.setState({ selectedJob: selectedOption });
        if (selectedOption) {

            this.getTasks(selectedOption);

        }
        else {

            this.setState({ pendingTasks: " " });
            this.setState({ remainingDays: " " });
            this.setState({ deadLine: " " });
        }
    }

    getTasks = (selectedOption) => {
        var subTask = [];

        this.setState({ pendingTasks: "Loading..." });
        this.setState({ remainingDays: "Loading..." });
        this.setState({ deadLine: "Loading..." });

        const selectedOptionId = typeof selectedOption == "object" ? selectedOption.value : selectedOption;

        // axios.post('http://localhost:5003/job/byId',{'id':selectedOption.value})
        axios.post(window.crmServer + '/job/byId', { 'id': selectedOptionId })
            .then(response => {
                var expectedDate = response.data.profileData[0].EXPECTED_DATE.substring(0, 10);

                var d = new Date();
                var today = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();

                var date1 = new Date(today);
                var date2 = new Date(response.data.profileData[0].EXPECTED_DATE.substring(0, 10));
                var timeDiff = date2.getTime() - date1.getTime();

                if (isNaN(timeDiff)) {
                    diffDays = '-';
                    expectedDate = '-';
                } else {
                    var diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));
                }

                this.setState({ remainingDays: diffDays });
                this.setState({ deadLine: expectedDate });

                var pendingTasks = 0;
                // let empRepair = "0";
                // let empCalibrate = "0";

                for (let i = 0; i < response.data.taskData.length; i++) {
                    for (let n = 0; n < response.data.subTaskData.length; n++) {
                        // console.log('sub task ', response.data.taskData[i].ID_JOB_TASK);

                        let empRepair = "0";
                        let empCalibrate = "0";

                        // console.log('sub task vs task matched from id_sub_task', response.data.subTaskData[n].ID_JOB_TASK, response.data.taskData[i].ID_JOB_TASK);
                        if (response.data.subTaskData[n].ID_JOB_TASK === response.data.taskData[i].ID_JOB_TASK) {

                            if (response.data.subTaskData[n].SUB_TASK_STATUS === 'Pending') {
                                pendingTasks = pendingTasks + 1;
                            }
                            // console.log('sub task state ', response.data.subTaskData);
                            for (let m = 0; m < response.data.assignEmpData.length; m++) {

                                if (response.data.subTaskData[n].ID_JOB_SUB_TASK === response.data.assignEmpData[m].ID_JOB_SUB_TASK) {

                                    if (response.data.assignEmpData[m].SUBTASK_ASSIGN_TYPE === 'R') {

                                        empRepair = response.data.assignEmpData[m].ID_EMPLOYEE;
                                    }

                                    if (response.data.assignEmpData[m].SUBTASK_ASSIGN_TYPE === 'C') {

                                        empCalibrate = response.data.assignEmpData[m].ID_EMPLOYEE;
                                    }
                                }
                            }
                            subTask.push({
                                sub_task: response.data.subTaskData[n].SUB_TASK_CODE,
                                instrument: response.data.subTaskData[n].SUB_TASK_INSTRUMENT,
                                remark: response.data.subTaskData[n].REMARK,
                                task: response.data.taskData[i].ID_TASK_CODE,
                                job: selectedOption.label,
                                status: response.data.subTaskData[n].SUB_TASK_STATUS,
                                type: response.data.subTaskData[n].SUB_TASK_TYPE,
                                repairBy: empRepair,
                                calibrateBy: empCalibrate,
                                id_registry: response.data.subTaskData[n].ID_JOB_REGISTRY,
                                id_task: response.data.subTaskData[n].ID_JOB_TASK,
                                id_sub_task: response.data.subTaskData[n].ID_JOB_SUB_TASK,
                            });
                        }
                    }
                }

                this.setState({ pendingTasks: pendingTasks });
                this.setState({ subTasks: subTask });
            });
    }


    assignTask = (data) => {
        var selectedOption = {

            value: data.id_job_registry,
            label: data.job_code
        }

        // axios.post('http://localhost:5003/job/assignTask',data)
        axios.post(window.crmServer + '/job/assignTask', data)
            .then(response => {

                if (response.data.status) {

                    this.props.alert.success(response.data.msg);
                    this.getTasks(selectedOption);
                }

                else {

                    this.props.alert.error(response.data.msg);
                    this.getTasks(selectedOption);
                }
            });
    }


    render() {
        const { classes } = this.props;


        if (this.state.loading) {
            return (

                <Loader />

            );
        }
        else {

            return (

                <React.Fragment>

                    <Toolbar className="flex flex-wrap pt-24 px-12">
                        <h2 className="w-full sm:w-1/4 subtitle-color">
                            Task Allocation
                        </h2>
                    </Toolbar>

                    <div className="p-20">
                        <div className="w-full md:w-1/4 inline-block mr-56">
                            <Select
                                options={this.state.activeJobs}
                                onChange={this.setSelectedJobs}
                                value={this.state.selectedJobs}
                                onBlurResetsInput={false}
                                onSelectResetsInput={false}
                                onCloseResetsInput={false}
                            />
                        </div>
                    </div>

                    <div className="block job-task-allocation-margin">
                        <div className="w-full md:w-1/5 inline-block">
                            <TextField
                                className=""
                                type="text"
                                name="job_pending_sub_task"
                                value={this.state.pendingTasks}
                                label="Pending Sub Tasks"
                                disabled
                            />
                        </div>

                        <div className="w-full md:w-1/5 inline-block">
                            <TextField
                                className=""
                                type="text"
                                name="job_remaining_days"
                                value={this.state.remainingDays}
                                label="Remaining Days"
                                disabled
                            />
                        </div>

                        <div className="w-full md:w-1/5 inline-block">
                            <TextField
                                className=""
                                type="text"
                                name="job_dead_line"
                                value={this.state.deadLine}
                                label="Dead Line"
                                disabled
                            />
                        </div>

                    </div>

                    <fieldset className="bank-deposit-form-color  mt-8 mr-16  p-8 pb-16">
                        <ReactTable
                            className={classNames(classes.root, "-striped -highlight m-12 p-20 border-2 border-green-darkest")}
                            getTrProps={(state, rowInfo, column) => {
                                return {
                                    className: "cursor-pointer",
                                }
                            }}
                            data={this.state.subTasks}
                            columns={[
                                {
                                    Header: "Sub Task",
                                    accessor: "sub_task",
                                    filterable: true,
                                    className: '',
                                    width: 150,
                                },
                                {
                                    Header: "Instrument",
                                    accessor: "instrument",
                                    filterable: true,
                                    className: "",
                                    width: 150,
                                },
                                {
                                    Header: "Status",
                                    accessor: "status",
                                    filterable: true,
                                    className: "justify-left",
                                    width: 100,
                                    Cell: row => (
                                        <div className="flex items-center">
                                            <Icon
                                                className={row.value === 'Pending' ? 'text-red-light'
                                                    : row.value === 'In Progress' ? 'text-orange-light'
                                                        : row.value === 'Completed' ? 'text-green-light'
                                                            : 'text-blue-light'}
                                                title={row.value}
                                            >
                                                {row.value === 'Completed' ? 'check_circle'
                                                    : row.value === 'Pending' ? `info`
                                                        : row.value === 'In Progress' ? `sync_problem`
                                                            : row.value === 'Assigned' ? `info`
                                                                : 'Other'}
                                            </Icon>
                                        </div>
                                    )
                                },

                                {
                                    Header: "Calibrate By     |      Repair By",
                                    className: "justify-right",
                                    Cell: row => (

                                        <div className="w-full">
                                            {(row.original.status === 'Pending' || row.original.status === 'Assigned') && row.original.type === 'RC' ? (
                                                <Formsy
                                                    onValidSubmit={this.assignTask}
                                                >
                                                    <TextFieldFormsy type="hidden" name="assign_date" value={this.state.assignDate} />
                                                    <TextFieldFormsy type="hidden" name="task_code" value={row.original.sub_task} />
                                                    <TextFieldFormsy type="hidden" name="task_calibrate_by_old" value={row.original.calibrateBy} />
                                                    <TextFieldFormsy type="hidden" name="task_repair_by_old" value={row.original.repairBy} />
                                                    <TextFieldFormsy type="hidden" name="id_job_registry" value={row.original.id_registry} />
                                                    <TextFieldFormsy type="hidden" name="id_job_task" value={row.original.id_task} />
                                                    <TextFieldFormsy type="hidden" name="id_job_sub_task" value={row.original.id_sub_task} />
                                                    <TextFieldFormsy type="hidden" name="sub_task_type" value={row.original.type} />
                                                    <TextFieldFormsy type="hidden" name="job_code" value={row.original.job} />

                                                    <SelectFormsy
                                                        className="w-full md:w-1/3 mx-20"
                                                        name="task_calibrate_by"
                                                        value={row.original.calibrateBy}
                                                        required
                                                    >
                                                        <MenuItem disabled value='0'>--Select--</MenuItem>
                                                        {this.state.employees.map(option => (
                                                            <MenuItem value={option.value}>
                                                                {option.toolTip ? (
                                                                    <Tooltip key={option.value} title={option.toolTip}>
                                                                        <span>{option.label}</span>
                                                                    </Tooltip>
                                                                ) : (
                                                                    option.label
                                                                )}
                                                            </MenuItem>
                                                        ))}
                                                    </SelectFormsy>

                                                    <SelectFormsy
                                                        className="w-full md:w-1/3 mx-12"
                                                        name="task_repair_by"
                                                        value={row.original.repairBy}
                                                        required
                                                    >
                                                        <MenuItem disabled value='0'>--Select--</MenuItem>
                                                        {this.state.employees.map(option => (
                                                            <MenuItem value={option.value}>
                                                                {option.toolTip ? (
                                                                    <Tooltip key={option.value} title={option.toolTip}>
                                                                        <span>{option.label}</span>
                                                                    </Tooltip>
                                                                ) : (
                                                                    option.label
                                                                )}
                                                            </MenuItem>
                                                        ))}
                                                    </SelectFormsy>

                                                    <Button
                                                        type="submit"
                                                        className="w-full md:w-1/5 mx-12"
                                                        variant="raised"
                                                        color="secondary"
                                                        size="small"
                                                    >
                                                        Assign
                                                    </Button>

                                                </Formsy>
                                            )
                                                : (row.original.status === 'Pending' || row.original.status === 'Assigned') && row.original.type === 'R' ? (
                                                    <Formsy
                                                        onValidSubmit={this.assignTask}
                                                        className={classNames(classes.root, "")}
                                                    >
                                                        <TextFieldFormsy type="hidden" name="assign_date" value={this.state.assignDate} />
                                                        <TextFieldFormsy type="hidden" name="task_code" value={row.original.sub_task} />
                                                        <TextFieldFormsy type="hidden" name="task_calibrate_by_old" value={row.original.calibrateBy} />
                                                        <TextFieldFormsy type="hidden" name="task_repair_by_old" value={row.original.repairBy} />
                                                        <TextFieldFormsy type="hidden" name="id_job_registry" value={row.original.id_registry} />
                                                        <TextFieldFormsy type="hidden" name="id_job_task" value={row.original.id_task} />
                                                        <TextFieldFormsy type="hidden" name="id_job_sub_task" value={row.original.id_sub_task} />
                                                        <TextFieldFormsy type="hidden" name="sub_task_type" value={row.original.type} />
                                                        <TextFieldFormsy type="hidden" name="job_code" value={row.original.job} />

                                                        <SelectFormsy
                                                            className="w-full md:w-1/3 mx-20"
                                                            name="task_calibrate_by"
                                                            value={row.original.calibrateBy}
                                                            required
                                                        >
                                                            <MenuItem disabled value='0'>--Select--</MenuItem>
                                                            {this.state.employees.map(option => (
                                                                <MenuItem value={option.value}>
                                                                    {option.toolTip ? (
                                                                        <Tooltip key={option.value} title={option.toolTip}>
                                                                            <span>{option.label}</span>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        option.label
                                                                    )}
                                                                </MenuItem>
                                                            ))}
                                                        </SelectFormsy>

                                                        <SelectFormsy
                                                            className="w-full md:w-1/3 mx-12"
                                                            name="task_repair_by"
                                                            value={row.original.repairBy}
                                                            required
                                                        >
                                                            <MenuItem disabled value='0'>--Select--</MenuItem>
                                                            {this.state.employees.map(option => (
                                                                <MenuItem value={option.value}>
                                                                    {option.toolTip ? (
                                                                        <Tooltip key={option.value} title={option.toolTip}>
                                                                            <span>{option.label}</span>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        option.label
                                                                    )}
                                                                </MenuItem>
                                                            ))}
                                                        </SelectFormsy>

                                                        <Button
                                                            type="submit"
                                                            className="w-full md:w-1/5 mx-12"
                                                            variant="raised"
                                                            color="secondary"
                                                            size="small"
                                                        >
                                                            Assign
                                                        </Button>

                                                    </Formsy>
                                                ) : (row.original.status === 'Pending' || row.original.status === 'Assigned') && row.original.type === 'C' ? (
                                                    <Formsy
                                                        onValidSubmit={this.assignTask}
                                                        className={classNames(classes.root, "")}
                                                    >
                                                        <TextFieldFormsy type="hidden" name="assign_date" value={this.state.assignDate} />
                                                        <TextFieldFormsy type="hidden" name="task_code" value={row.original.sub_task} />
                                                        <TextFieldFormsy type="hidden" name="task_calibrate_by_old" value={row.original.calibrateBy} />
                                                        <TextFieldFormsy type="hidden" name="task_repair_by_old" value={row.original.repairBy} />
                                                        <TextFieldFormsy type="hidden" name="id_job_registry" value={row.original.id_registry} />
                                                        <TextFieldFormsy type="hidden" name="id_job_task" value={row.original.id_task} />
                                                        <TextFieldFormsy type="hidden" name="id_job_sub_task" value={row.original.id_sub_task} />
                                                        <TextFieldFormsy type="hidden" name="sub_task_type" value={row.original.type} />
                                                        <TextFieldFormsy type="hidden" name="job_code" value={row.original.job} />

                                                        <SelectFormsy
                                                            className="w-full md:w-1/3 mx-20"
                                                            name="task_calibrate_by"
                                                            value={row.original.calibrateBy}
                                                            required
                                                        >
                                                            <MenuItem disabled value='0'>--Select--</MenuItem>
                                                            {this.state.employees.map(option => (
                                                                <MenuItem value={option.value}>
                                                                    {option.toolTip ? (
                                                                        <Tooltip key={option.value} title={option.toolTip}>
                                                                            <span>{option.label}</span>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        option.label
                                                                    )}
                                                                </MenuItem>
                                                            ))}
                                                        </SelectFormsy>

                                                        <SelectFormsy
                                                            className="w-full md:w-1/3 mx-12"
                                                            name="task_repair_by"
                                                            value={row.original.repairBy}
                                                            required
                                                        >
                                                            <MenuItem disabled value='0'>--Select--</MenuItem>
                                                            {this.state.employees.map(option => (
                                                                <MenuItem value={option.value}>
                                                                    {option.toolTip ? (
                                                                        <Tooltip key={option.value} title={option.toolTip}>
                                                                            <span>{option.label}</span>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        option.label
                                                                    )}
                                                                </MenuItem>
                                                            ))}
                                                        </SelectFormsy>

                                                        <Button
                                                            type="submit"
                                                            className="w-full md:w-1/5 mx-12"
                                                            variant="raised"
                                                            color="secondary"
                                                            size="small"
                                                        >
                                                            Assign
                                                        </Button>

                                                    </Formsy>
                                                ) : (
                                                    <Formsy
                                                        onValidSubmit={this.assignTask}
                                                        className={classNames(classes.root, "")}
                                                    >
                                                        <TextFieldFormsy type="hidden" name="assign_date" value={this.state.assignDate} />
                                                        <TextFieldFormsy type="hidden" name="task_code" value={row.original.sub_task} />
                                                        <TextFieldFormsy type="hidden" name="task_calibrate_by_old" value={row.original.calibrateBy} />
                                                        <TextFieldFormsy type="hidden" name="task_repair_by_old" value={row.original.repairBy} />
                                                        <TextFieldFormsy type="hidden" name="id_job_registry" value={row.original.id_registry} />
                                                        <TextFieldFormsy type="hidden" name="id_job_task" value={row.original.id_task} />
                                                        <TextFieldFormsy type="hidden" name="id_job_sub_task" value={row.original.id_sub_task} />
                                                        <TextFieldFormsy type="hidden" name="sub_task_type" value={row.original.type} />
                                                        <TextFieldFormsy type="hidden" name="job_code" value={row.original.job} />

                                                        <SelectFormsy
                                                            className="w-full md:w-1/3 mx-20"
                                                            name="task_calibrate_by"
                                                            value={row.original.calibrateBy}
                                                            required
                                                        >
                                                            <MenuItem disabled value='0'>--Select--</MenuItem>
                                                            {this.state.employees.map(option => (
                                                                <MenuItem value={option.value}>
                                                                    {option.toolTip ? (
                                                                        <Tooltip key={option.value} title={option.toolTip}>
                                                                            <span>{option.label}</span>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        option.label
                                                                    )}
                                                                </MenuItem>
                                                            ))}
                                                        </SelectFormsy>

                                                        <SelectFormsy
                                                            className="w-full md:w-1/3 mx-12"
                                                            name="task_repair_by"
                                                            value={row.original.repairBy}
                                                            required
                                                        >
                                                            <MenuItem disabled value='0'>--Select--</MenuItem>
                                                            {this.state.employees.map(option => (
                                                                <MenuItem value={option.value}>
                                                                    {option.toolTip ? (
                                                                        <Tooltip key={option.value} title={option.toolTip}>
                                                                            <span>{option.label}</span>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        option.label
                                                                    )}
                                                                </MenuItem>
                                                            ))}
                                                        </SelectFormsy>

                                                        <Button
                                                            type="submit"
                                                            className="w-full md:w-1/5 mx-12"
                                                            variant="raised"
                                                            color="secondary"
                                                            size="small"
                                                        >
                                                            Assign
                                                        </Button>

                                                    </Formsy>
                                                )}
                                        </div>
                                    )
                                },

                            ]}
                            defaultPageSize={10}
                            noDataText="No Tasks found"
                        />
                    </fieldset>

                </React.Fragment>
            );
        }
    }

    componentWillMount() {

        var jobData = [];

        // axios.get('http://localhost:5003/job/min')
        axios.get(window.crmServer + '/job/min')
            .then(job => {
                axios.get(window.crmServer + '/crm/getCustomer/min')
                    .then(customer => {

                        for (let i = 0; i < job.data.result.length; i++) {
                            for (let n = 0; n < customer.data.result.length; n++) {
                                // Check if CUSTOMER_ID is matched and CUSTOMER_PROFILE is defined
                                if (job.data.result[i].CUSTOMER_ID === customer.data.result[n]._id && customer.data.result[n].CUSTOMER_PROFILE) {
                                    // Check if cx_name is defined before accessing it
                                    let CX_NAME = customer.data.result[n].CUSTOMER_PROFILE.cx_name != "" && customer.data.result[n].CUSTOMER_PROFILE.cx_name != null ? customer.data.result[n].CUSTOMER_PROFILE.cx_name : "";
                                    const LEVEL = job.data.result[i].PRIORITY_LEVEL ? ' (' + job.data.result[i].PRIORITY_LEVEL + ')' : "";
                                    const JOB_CODE = job.data.result[i].JOB_CODE != "" && job.data.result[i].JOB_CODE != null ? job.data.result[i].JOB_CODE : "";

                                    jobData.push({
                                        value: job.data.result[i].ID_JOB_REGISTRY,
                                        label: job.data.result[i].JOB_CODE_PREFIX + ' ' + JOB_CODE + ' / ' + CX_NAME + LEVEL
                                    });
                                }
                            }
                        }

                        this.setState({ activeJobs: jobData });
                    });

            });

        var employee = [];

        //axios.get('http://localhost:5002/getEmployeeNameIdWithOutSupervisors')
        axios.get(window.hrmServer + '/getEmployeeNameIdWithOutSupervisors')
            .then(response => {

                for (let i = 0; i < response.data.result.length; i++) {
                    // const addressData = response.data.employees[i].CURRENT_ADDRESS_CITY;
                    // const empAddress = addressData != null && addressData != "" && addressData != "Select City" ? '(' + addressData + ')' : "";
                    // employee.push({
                    //     value: response.data.employees[i].ID_EMPLOYEE_PROFILE,
                    //     label: response.data.employees[i].FIRSTNAME + ' ' + response.data.employees[i].LASTNAME + empAddress,
                    //     toolTip: response.data.employees[i].CURRENT_ADDRESS
                    // });
                    employee.push({
                        value: response.data.result[i].ID_EMPLOYEE_PROFILE,
                        label: response.data.result[i].FIRST_NAME
                    });
                }
                this.setState({ employees: employee });
            });

    }
}

export default withStyles({ withTheme: true })(withRouter(connect()(withAlert(jobNew))));


// WEBPACK FOOTER //
// ./src/main/content/crm/jobTaskAllocation/jobTaskAllocation.js